import { Component, OnInit, ChangeDetectionStrategy, inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { ProductTaskBoard } from 'src/app/models/product_task_board.model';
import { ApiService } from 'src/app/services/api.service';
import { UserService } from 'src/app/services/user.service';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { firstValueFrom } from 'rxjs';
import { ProductTaskCommentOriginEnum } from 'src/app/enums/product-task-comment-origin.enum';

@Component({
  selector: 'app-task-to-deadlock-dialog',
  templateUrl: './task-to-deadlock-dialog.component.html',
  styleUrl: './task-to-deadlock-dialog.component.css',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    MatDialogTitle,
    CdkScrollable,
    MatDialogContent,
    FormsModule,
    ReactiveFormsModule,
    MatFormField,
    MatLabel,
    MatInput,
    MatDialogActions,
    MatButton,
    MatIcon,
  ],
})
export class TaskToDeadlockDialogComponent implements OnInit {
  dialogRef = inject<MatDialogRef<TaskToDeadlockDialogComponent>>(MatDialogRef);
  data = inject<{
    product_task_board_id: number;
    company_product_id: number;
    product_task_id: number;
    direction: 'in' | 'out';
  }>(MAT_DIALOG_DATA);
  private api = inject(ApiService);
  protected fb = inject(FormBuilder);
  private user = inject(UserService);

  product_task_board: ProductTaskBoard | undefined;
  form: FormGroup;

  constructor() {
    this.form = this.fb.group({
      product_task_id: [this.data.product_task_id, Validators.compose([Validators.required])],
      content: ['', Validators.compose([Validators.required, Validators.minLength(20)])],
      user_id: [this.user.getCurrentUser().id, Validators.compose([Validators.required])],
      origin: [
        this.data.direction === 'in' ? ProductTaskCommentOriginEnum.DEADLOCK_IN : ProductTaskCommentOriginEnum.DEADLOCK_OUT,
        Validators.compose([Validators.required]),
      ],
    });
  }

  ngOnInit(): void {
    this.fetchTask();
  }

  async submit() {
    const payload = {
      ...this.form.value,
      content: String(this.form.value.content ?? '').replace(/\r\n|\r|\n/g, '<br>'),
    };
    this.product_task_board!.product_task.comments.push(await firstValueFrom(this.api.createComment(payload)));
    this.dialogRef.close(this.product_task_board);
  }

  private fetchTask() {
    const with_string: string =
      'product_task..tags,product_task..company_product_epic,product_task..product_task_listeners,product_task_board_time_budgets..budgetable,product_task_board_time_budgets..assignee,active_product_task_board_time_budget..assignee,active_product_task_board_time_budget..budgetable,product_task..comments';

    this.api.getProductTaskBoard(this.data.product_task_board_id, { with: with_string, append: 'ro_time_registered' }).subscribe({
      next: data => {
        this.product_task_board = data;
      },
    });
  }
}
